import React from 'react';
import { Table, Card, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import styles from './Disk.module.scss';

const DiskInfo = ({ diskInfo }) => {
  // 디스크 정보 파싱
  const parseDiskInfo = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      const disks = [];
      const lines = data.trim().split('\n');
      
      // 헤더 라인 건너뛰기
      const dataLines = lines.slice(1);
      
      dataLines.forEach(line => {
        const parts = line.trim().split(/\s+/);
        if (parts.length >= 6) {
          const name = parts[0];
          const size = parts[3];
          const type = parts[5];
          
          disks.push({
            name,
            size,
            type,
            model: parts.slice(6).join(' '),
            key: name
          });
        }
      });
      
      return disks;
    } catch (error) {
      console.error('Error parsing disk info:', error);
      return [];
    }
  };

  const disks = parseDiskInfo(diskInfo);

  return (
    <Card 
      title={
        <div>
          디스크 정보
          <Tooltip title="시스템에 장착된 물리적 디스크 정보입니다.">
            <InfoCircleOutlined style={{ marginLeft: 8 }} />
          </Tooltip>
        </div>
      } 
      className={styles.diskCard}
    >
      <Table 
        dataSource={disks}
        rowKey="name"
        pagination={false}
        columns={[
          { title: '디스크 이름', dataIndex: 'name', key: 'name' },
          { title: '크기', dataIndex: 'size', key: 'size' },
          { title: '유형', dataIndex: 'type', key: 'type' },
          { title: '모델', dataIndex: 'model', key: 'model' }
        ]}
      />
    </Card>
  );
};

export default DiskInfo;